<!-- src/app/features/auth/login/login-successfully.component.html -->

<div class="container-fluid d-flex align-items-center justify-content-center min-vh-100 bg-light">
  <div class="col-md-8 col-lg-6">
    <!-- Logo Section -->
    <div class="text-center mb-4">
      <img 
        src="https://www.sigvaris.com/globalassets/_div/sig9000_sigvaris_group_160th_logo_dual_horizontal_darkblue_rgb.svg?ref=FD8B1C8BB4" 
        alt="Sigvaris Group Logo" 
        class="img-fluid mb-3" 
        style="max-width: 200px; height: 120px;">
    </div>
    
    <!-- Success or Error Card -->
    <div class="card custom-card" [style.display]="currentState === 'loading' ? 'block' : 'none'">
      <div class="card-body" style="padding-left: 25px; padding-right: 25px;">
     
        <!-- Mostrar apenas se for a instância ativa -->
        <div>
          
          <!-- Loading State -->
          <div >
            <h2 class="card-title text-center mb-4">Validating Session...</h2>
            
            <!-- Loading Indicator -->
            <div class="text-center mb-4">
              <p class="lead">Please wait while we verify your session.</p>
              <div class="spinner-border text-primary" role="status">
                <span class="visually-hidden">Loading...</span>
              </div>
            </div>
          </div>

        

          
        </div>
        
      </div>
    </div>


<div class="card custom-card" [style.display]="currentState === 'success' ? 'block' : 'none'">
      <div class="card-body" style="padding-left: 25px; padding-right: 25px;">
     
        <!-- Mostrar apenas se for a instância ativa -->
        <div>
          

          <div >
            <h2 class="card-title text-center mb-4">Login Successful</h2>
            
            <!-- Success Message -->
            <div class="text-center mb-4">
              <p class="lead">Welcome back! You have successfully logged in.</p>
              <p>You will be redirected to the <strong>order creation page...</strong></p>
            </div>
          </div>
        

          
        </div>
        
      </div>
    </div>

  <!-- Success State -->
          


  </div>
  
</div>